var render = function render(){var _vm=this,_c=_vm._self._c;return _c('ds-chip',{staticClass:"merge-field-chip",class:{ 'overflow-chip': _vm.isOverflow },attrs:{"slot":"reference"},slot:"reference",scopedSlots:_vm._u([{key:"leading",fn:function(){return [_c('ds-icon',{staticClass:"merge-icon",attrs:{"name":"merge-field"}})]},proxy:true}])},[_vm._v(" "+_vm._s(_vm.label)+" ")])
}
var staticRenderFns = []

export { render, staticRenderFns }